import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPharma = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9706_13064)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M25 50L21.875 43.75L15 45M25 10L21.875 16.25L15 15M26.4625 37.5H25M25 37.5L17.5 52.5M25 37.5L21.25 30M5 30H21.25M21.25 30L25 22.5M25 22.5L17.5 7.5M25 22.5H30M10 25L13.75 30L10 35",
			stroke: "#0A3C93",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M37.9278 4.21573L52.07 4.21573M44.9989 14.8223L44.9989 4.21573M52.07 14.8223L52.07 38.7383C52.07 42.2739 49.4183 44.9255 46.0596 44.7487L43.9382 44.7487C40.4027 44.7487 37.7511 42.0971 37.9278 38.7383L37.9278 14.8223M37.9278 28.5355L52.07 28.5355M44.9989 44.7487L44.9989 52.8553M34.3923 14.8223L55.6055 14.8223",
			stroke: "#0A3C93",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9706_13064",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			fill: "white"
		})
	}) })]
});
export default SvgPharma;
